import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CoreModule} from '../core/core.module';
import {exportComponents, exportServices} from './index';
import {SharedModule} from '../shared/shared.module';
import {DynamicFormModule} from '../shared/dynamic-form/dynamic-form.module';
import {LayoutModule} from '../layout/layout.module';
import {EditorModule,} from 'primeng/editor';
import {SelectButtonModule} from 'primeng/selectbutton';
import {SharedModule as PNGShared} from 'primeng/api';
import {TableModule} from 'primeng/table';
import {ClickOutsideModule} from 'ng-click-outside';
import {CheckboxModule} from 'primeng/checkbox';
import {DropdownModule} from 'primeng/dropdown';

@NgModule({
    imports: [
      CommonModule,
      CoreModule,
      TableModule,
      ClickOutsideModule,
      SharedModule,
      EditorModule,
      LayoutModule,
      DynamicFormModule,
      SelectButtonModule,
      PNGShared,
      CheckboxModule,
      DropdownModule
    ],
    declarations: [...exportComponents],
    exports: [...exportComponents],
    providers: [...exportServices]
  })

  export class ExportModule { }
